<template>
    <v-layout column wrap>
        <v-flex xs12 v-if="files.length > 0">
            <ul class="file-list">
                <li class="file-item" v-for="file in files" v-bind:key="file.fileId">
                    <v-layout row wrap>
                        <v-flex xs9 md10 lg10>
                            <div class="file-name">{{ file.name }}
                                <span v-if="file.success"><i class="fa fa-check-circle upload-success"></i></span>
                                <span v-if="!!file.error"><i class="fa fa-times-circle upload-fail"></i></span>
                            </div>
                            <div v-if="file.sent" class="file-sent">{{ $t('files.sent.title') }}</div>
                            <div v-if="file.size" class="file-size">{{ file.size | FormatBytes($i18n)}}</div>
                            <div v-if="!!file.error" class="error-text">{{ file.error }}</div>
                        </v-flex>
                        <v-flex xs3 md2 lg2>
                            <v-btn :disabled="readOnly" flat icon small @click.prevent="handleDeleteButtonClick(file)">
                                <v-icon small>fas fa-trash</v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex v-if="!file.success && file.progress < 100">
                            <v-progress-linear  v-model="file.progress"></v-progress-linear>
                        </v-flex>
                    </v-layout>
                </li>
            </ul>
        </v-flex>
        <v-flex>
            <file-upload
                    v-if="!readOnly"
                    class="v-btn theme--light success"
                    ref="upload"
                    v-model="intFiles"
                    :post-action="getUploadUrl()"
                    multiple
                    :customAction="customAction"
                    @input-file="inputFile"
            >{{ $t('files.buttons.uploadFile.title') }}<v-icon right dark>cloud_upload</v-icon>
            </file-upload>
        </v-flex>
    </v-layout>
</template>

<script>
  import FormatBytes from '../Filters/FormatBytes'
  import _ from 'lodash'
  const { getBaseClientAccountApiURL } = require('../../helpers/baseurl')

  export default {
    name: "files",
    props: {
      files: {
        Type: Array
      },
      readOnly: {
        Type: Boolean
      }
    },
    filters: {
      FormatBytes
    },
    data () {
      return {

      }
    },
    computed: {
      intFiles: {
        get () {
          return this.files
        },
        set (files) {
          this.$emit('updateFiles', files)
        }
      }
    },
    methods: {
      getUploadUrl () {
        return getBaseClientAccountApiURL() + 'cases/upload-file'
      },
      inputFile(newFile, oldFile) {
        // Automatic upload
        if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
          if (!this.$refs.upload.active) {
            this.$refs.upload.active = true
          }
        }
      },
      async customAction(file, component) {
        // return await component.uploadPut(file)
        let result = await component.uploadHtml5(file)
        const response = result.response

        if (response.error !== null) {
          let resultErrors = []
          for (let key in response.error) {
            if (!response.error.hasOwnProperty(key)) {
              continue
            }

            resultErrors.push(response.error[key])
          }
          result.error = _.join(resultErrors, '; ')
          result.success = false

          return result
        }

        let fileId = _.get(response.data, 'fileId', null)

        if (fileId === null) {
          result.error = this.$t('files.errors.unableToUploadFile')
          result.success = false

          return result
        }

        result.fileId = fileId

        return result
      },
      handleDeleteButtonClick (file) {
        //Если файл только загружен, удаляем его средствами аплоадера
        if (file.file) {
          const uploader = _.get(this.$refs, 'upload', null)

          if (uploader === null) {
            return
          }

          this.$refs['upload'].remove(file)
          return
        }

        let index = _.findIndex(this.files, function (item) {
          return item.id === file.id
        })

        let updatedFiles = _.cloneDeep(this.files)
        updatedFiles.splice(index, 1)

        this.$emit('updateFiles', updatedFiles)
      }
    }
  }
</script>

<style scoped>
    .file-list {
        list-style: none;
    }
    .file-list .error-text {
        color: #ff5252;
        font-size: 11px;
    }
    .file-list .file-name {
        font-weight: 500;
    }
    .file-list .file-item {
        margin-top: 10px;
        padding: 10px;
    }
    .file-list .file-item:hover {
        background: rgba(0,0,0,.04);
    }
    .file-list .upload-success {
        color: #4CAF50;
    }
    .file-list .upload-fail {
        color: #ff5252;
    }
    .file-list .file-size {
        font-size: 11px;
        opacity: .7;
    }
    .file-list .file-sent {
        font-size: 11px;
        opacity: .7;
    }
</style>
<style>
    .file-uploads {
        overflow: hidden;
        position: relative;
        text-align: center;
        display: inline-flex !important;
    }
    .file-uploads label {
        cursor: pointer;
    }
    .file-uploads.file-uploads-html4 input[type="file"] {
        opacity: 0;
        font-size: 20em;
        z-index: 1;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        position: absolute;
        width: 100%;
        height: 100%;
    }
    .file-uploads.file-uploads-html5 input[type="file"] {
        overflow: hidden;
        position: fixed;
        width: 1px;
        height: 1px;
        z-index: -1;
        opacity: 0;
    }
</style>